
function swiperStage() {

    const el = document.querySelector('.stage-swiper');

    if (!el || typeof Swiper === 'undefined') {
        return;
    }

    const nextBtn = el.querySelector('.swiper-button-next');
    const prevBtn = el.querySelector('.swiper-button-prev');
    const pagination = el.querySelector('.swiper-pagination');
    const autoplayBtn = el.querySelector('.swiper-autoplay-toggle');

    const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;

    const isDesktop = window.innerWidth >= 1200;

    const swiper = new Swiper(el, {

        // Animation
        speed: reducedMotion ? 0 : 600,
        parallax: isDesktop && !reducedMotion,

        // Autoplay
        autoplay: reducedMotion ? false : {
            delay: 7600,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
            waitForTransition: true,
        },

        // Navigation
        grabCursor: true,
        navigation: {
            addIcons: false,
            nextEl: nextBtn,
            prevEl: prevBtn,
        },

        // Pagination
        pagination: {
            el: pagination,
            clickable: true,
        },

        // Keyboard
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },

        // Accessibility
        a11y: {
            enabled: true,

            prevSlideMessage: prevBtn.dataset.swiperLabel,
            nextSlideMessage: nextBtn.dataset.swiperLabel,

            slideRole: 'group',
            slideLabelMessage: '{{index}} / {{slidesLength}}',

            paginationBulletMessage: 'Zu Beitrag {{index}}',
        },

        on: {
            init(swiper) {
                updateAutoplayButton(swiper);
                updateSlideFocus(swiper);
            },

            slideChange(swiper) {
                updateSlideFocus(swiper);
            },

            autoplayStart(swiper) {
                updateAutoplayButton(swiper);
            },

            autoplayStop(swiper) {
                updateAutoplayButton(swiper);
            },
        },
    });

    // Pause autoplay only when navigating with the keyboard.
    el.addEventListener('focusin', (event) => {
        if (
            event.target.matches(':focus-visible') &&
            swiper.autoplay.running
        ) {
            swiper.autoplay.stop();
        }
    });

    // Hide autoplay control when reduced motion is preferred.
    if (reducedMotion && autoplayBtn) {
        autoplayBtn.hidden = true;
    }

    // User-controlled pause / resume.
    autoplayBtn?.addEventListener('click', () => {
        if (swiper.autoplay.running) {
            swiper.autoplay.stop();
        } else if (!reducedMotion) {
            swiper.autoplay.start();
        }

        updateAutoplayButton(swiper);
    });

    
    function updateAutoplayButton(swiper) {
        if (!autoplayBtn) return;

        const running = swiper.autoplay.running;

        autoplayBtn.setAttribute(
            'aria-label',
            running
                ? autoplayBtn.dataset.labelPause
                : autoplayBtn.dataset.labelPlay
        );

        const pauseIcon = autoplayBtn.querySelector('.swiper-icon-pause');
        const playIcon = autoplayBtn.querySelector('.swiper-icon-play');

        pauseIcon?.classList.toggle('hidden', !running);
        playIcon?.classList.toggle('hidden', running);
    }


    function updateSlideFocus(swiper) {
        swiper.slides.forEach((slide, index) => {
            const active = index === swiper.activeIndex;

            // Prevent keyboard focus and screenreader access
            // to inactive slides.
            slide.inert = !active;
        });
    }
}

export { swiperStage };
